const antennaCategoryMap: Record<string, string> = {
  reg: 'Registered',
  nonreg: 'Unregistered',
  singleAntenna: 'Single Antenna',
  multipleAntenna: 'Multiple Antenna',
};

const fccColors: Record<string, string> = {
  'Broadcast by Channel': 'black',
  'Broadcast Microwave': 'green',
  'ASR Towers': 'blue',
  'AM Stations': 'blue',
  'FM Stations': 'purple',
};

const fccTypeColorMap = (type: string) => {
  for (const key in fccColors) {
    if (type.includes(key)) {
      return fccColors[key];
    }
  }

  return 'black';
};

const createAntennaSearchUrl = (properties: GeoJSON.GeoJsonProperties) => {
  if (!properties) return '';

  const antennaType = properties.category || '';
  const uniqueSystemIdentifier = properties.unique_sys || '';
  const callSign = properties.call_sign || '';
  const locationNumber = properties.location_n || '';
  const registrationNumber = properties.registrati || '';
  const faaStudyNumber = properties.faa_study_ || '';

  if (antennaType === 'reg') {
    return `https://www.antennasearch.com/HTML/individual/regTower.php?registration_number=${registrationNumber}`;
  } else if (antennaType === 'nonreg') {
    return `https://www.antennasearch.com/HTML/individual/nonregTower.php?faa_study_number=${faaStudyNumber.toUpperCase()}`;
  } else if (antennaType === 'singleAntenna') {
    return `https://www.antennasearch.com/HTML/individual/antenna.php?unique_system_identifier=${uniqueSystemIdentifier}&call_sign=${callSign}&location_number=${locationNumber}`;
  } else {
    return '';
  }
};

export { antennaCategoryMap, fccTypeColorMap, createAntennaSearchUrl, fccColors };
